import { createSelector } from '@reduxjs/toolkit';
import { composeAccumulator } from "../../../utils";
import { selectRedesignMobileConnectionPrice } from "../../MobileTariff/store";
import { selectConvergentData, selectMobileAndConvergentTariffPrice } from "../../../store/selectors";
export var selectPrice = selectMobileAndConvergentTariffPrice;
export var selectRatePeriodDays = function selectRatePeriodDays(state) {
  var _selectRedesignMobile, _selectRedesignMobile2;
  return (_selectRedesignMobile = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile === void 0 ? void 0 : (_selectRedesignMobile2 = _selectRedesignMobile.data) === null || _selectRedesignMobile2 === void 0 ? void 0 : _selectRedesignMobile2.rcRatePeriodDays;
};
export var selectBillingDate = function selectBillingDate(state) {
  var _selectRedesignMobile3, _selectRedesignMobile4;
  return (_selectRedesignMobile3 = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile3 === void 0 ? void 0 : (_selectRedesignMobile4 = _selectRedesignMobile3.data) === null || _selectRedesignMobile4 === void 0 ? void 0 : _selectRedesignMobile4.billingDate;
};
export var selectTitle = function selectTitle(state) {
  var _selectConvergentData;
  return (_selectConvergentData = selectConvergentData(state)) === null || _selectConvergentData === void 0 ? void 0 : _selectConvergentData.title;
};
var selectInternet = function selectInternet(state) {
  var _selectConvergentData2;
  return ((_selectConvergentData2 = selectConvergentData(state)) === null || _selectConvergentData2 === void 0 ? void 0 : _selectConvergentData2.internet) || {};
};
export var selectInternetIcon = function selectInternetIcon(state) {
  var _selectInternet;
  return (_selectInternet = selectInternet(state)) === null || _selectInternet === void 0 ? void 0 : _selectInternet.icon;
};
var selectTV = function selectTV(state) {
  var _selectConvergentData3;
  return ((_selectConvergentData3 = selectConvergentData(state)) === null || _selectConvergentData3 === void 0 ? void 0 : _selectConvergentData3.tv) || {};
};
export var selectTVIcon = function selectTVIcon(state) {
  var _selectTV;
  return (_selectTV = selectTV(state)) === null || _selectTV === void 0 ? void 0 : _selectTV.icon;
};
var selectTechnicalInfo = function selectTechnicalInfo(state) {
  var _selectConvergentData4;
  return ((_selectConvergentData4 = selectConvergentData(state)) === null || _selectConvergentData4 === void 0 ? void 0 : _selectConvergentData4.technicalInfo) || {};
};
export var selectAddress = function selectAddress(state) {
  var _selectTechnicalInfo;
  return (_selectTechnicalInfo = selectTechnicalInfo(state)) === null || _selectTechnicalInfo === void 0 ? void 0 : _selectTechnicalInfo.address;
};
export var selectConvergentAccumulators = createSelector([selectInternet, selectInternetIcon, selectTV, selectTVIcon], function (internet, internetImage, tv, tvImage) {
  return [composeAccumulator({
    iconSrc: internetImage,
    value: internet.value,
    unit: internet.unit
  }), composeAccumulator({
    iconSrc: tvImage,
    value: tv.value,
    unit: "".concat(tv.tabName, "-").concat(tv.unit)
  })].filter(function (item) {
    return !!item;
  });
});